import { render, staticRenderFns } from "./ingredientList.vue?vue&type=template&id=97008738&"
import script from "./ingredientList.vue?vue&type=script&lang=js&"
export * from "./ingredientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports